/** Account deactivation reasons, ported from anp-fe's `DELETE_ACC_OPTIONS`.
 * The keys index into `profile.deactivate.reasons.*`; the submitted value is
 * the translated label (the backend stores free text, not an id). */
export const DEACTIVATION_REASON_KEYS = [
  "temporaryAcc",
  "noLongerInterested",
  "alternative",
  "price",
  "needs",
  "service",
  "other",
] as const;

export type DeactivationReasonKey = (typeof DEACTIVATION_REASON_KEYS)[number];

/** Picking this reason reveals a free-text field, whose content is sent
 * instead of the canned label. */
export const OTHER_REASON_KEY: DeactivationReasonKey = "other";
